/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftGenerateData model module.
 * @module model/NftGenerateData
 * @version 1.0
 */
class NftGenerateData {
    /**
     * Constructs a new <code>NftGenerateData</code>.
     * @alias module:model/NftGenerateData
     */
    constructor() { 
        
        NftGenerateData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGenerateData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGenerateData} obj Optional instance to populate.
     * @return {module:model/NftGenerateData} The populated <code>NftGenerateData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGenerateData();

            if (data.hasOwnProperty('generateNo')) {
                obj['generateNo'] = ApiClient.convertToType(data['generateNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('nftCount')) {
                obj['nftCount'] = ApiClient.convertToType(data['nftCount'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = ApiClient.convertToType(data['nftSeal'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGenerateData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGenerateData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }

        return true;
    }


}



/**
 * @member {Number} generateNo
 */
NftGenerateData.prototype['generateNo'] = undefined;

/**
 * @member {String} title
 */
NftGenerateData.prototype['title'] = undefined;

/**
 * @member {Number} nftCount
 */
NftGenerateData.prototype['nftCount'] = undefined;

/**
 * @member {Number} status
 */
NftGenerateData.prototype['status'] = undefined;

/**
 * @member {Number} nftSeal
 */
NftGenerateData.prototype['nftSeal'] = undefined;

/**
 * @member {Number} accountNo
 */
NftGenerateData.prototype['accountNo'] = undefined;

/**
 * @member {Date} createdAt
 */
NftGenerateData.prototype['createdAt'] = undefined;






export default NftGenerateData;

